export function BranchContactMatchesCtrl ($uibModalInstance, $q, $scope, $translate, matches) {
  $scope.matches = matches;
  $scope.selectedItems = []

  $scope.tableSettings = {
    columns: [
      {
        field : 'display_name',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.NAME')
        }
      },
      {
        field : 'address1',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.ADDRESS', { num: "1" })
        }
      },
      {
        field : 'email',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.EMAIL')
        }
      },
      {
        field : 'phone',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.PHONE')
        }
      }
    ],
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  $scope.onRowClick = function (event) {
    $scope.selectedItems = $scope.matches.filter((match) => match.selected)
  };

  $scope.confirm = function () {
    $uibModalInstance.close($scope.selectedItems[0]);
  }

}
